import { MutableRefObject, useEffect, useRef } from 'react';
import Image from 'next/image';
import style from './slider.module.scss';

/** Slider is always applied to a center image.
 * If you change the number of slides, consider changing
 * .slider__item:nth-child(7) selector.
 */
const slides = [
  '/givingli-images/givingli-cards/card-1.png',
  '/givingli-images/givingli-cards/card-2.png',
  '/givingli-images/givingli-cards/card-3.png',
  '/givingli-images/givingli-cards/card-4.png',
  '/givingli-images/givingli-cards/card-5.png',
  '/givingli-images/givingli-cards/card-6.png',
  '/givingli-images/givingli-cards/card-7.png',
  '/givingli-images/givingli-cards/card-8.png',
  '/givingli-images/givingli-cards/card-9.png',
  '/givingli-images/givingli-cards/card-10.png',
  '/givingli-images/givingli-cards/card-11.png',
  '/givingli-images/givingli-cards/card-12.png',
  '/givingli-images/givingli-cards/card-13.png',
];

/** Should be in consistency with
 *  .slider__item:nth-child(7) animation duration which us 10s also
 */
const ANIMATION_INTERVAL = 10000; // 10 seconds

let timeoutId: NodeJS.Timeout;

const Slider = () => {
  const stream = useRef() as MutableRefObject<HTMLDivElement>;

  useEffect(() => {
    planNextStep();
    return () => clearTimeout(timeoutId);
  }, []);

  const slideNext = () => {
    if (!stream.current) {
      return;
    }
    planNextStep();
    const items = stream.current.getElementsByClassName(style.slider__item) as HTMLCollectionOf<HTMLDivElement>;
    Array.from(items).map((item) => {
      item.classList.remove(style.animated_right, style.animated_left);
      void item.offsetWidth; // Dirty hack to force class reassign and animation restart
      item.classList.add(style.animated_right);
    });
    stream.current.appendChild(items[0]);
  };

  const slidePrev = () => {
    if (!stream.current) {
      return;
    }
    planNextStep();
    const items = stream.current.getElementsByClassName(style.slider__item) as HTMLCollectionOf<HTMLDivElement>;
    Array.from(items).map((item) => {
      item.classList.remove(style.animated_right, style.animated_left);
      void item.offsetWidth; // Dirty hack to force class reassign and animation restart
      item.classList.add(style.animated_left);
    });
    stream.current.insertBefore(items[items.length - 1], items[0]);
  };

  const planNextStep = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      slideNext();
    }, ANIMATION_INTERVAL);
  };

  return (
    <>
      <div className={`${style.slider__mockup}`}>
        <Image src={'/givingli-images/mockup.png'} layout={'fill'} />
      </div>
      <div className={`${style.slider}`} ref={stream}>
        {slides.map((item: any, index: number) => {
          return (
            <div key={index} className={style.slider__item}>
              <Image sizes="300px" alt="slider-card" src={item} layout={'fill'} />
            </div>
          );
        })}
      </div>
      <div className={style.slider__buttons}>
        <button
          aria-label="prev-button"
          className={`${style.slider__button_prev} ${style.slider__button} slider-button-prev`}
          onClick={slidePrev}
        >
          <Image alt="prev-button" src={'/givingli-images/icons/icn_prev.png'} height="32px" width="32px" />
        </button>
        <button
          aria-label="next-button"
          className={`${style.slider__button_next} ${style.slider__button} slider-button-next`}
          onClick={slideNext}
        >
          <Image alt="next-button" src={'/givingli-images/icons/icn_next.png'} height="32px" width="32px" />
        </button>
      </div>
    </>
  );
};

export default Slider;
